import { clsx } from '@team/clsx';
import { Misc } from '@team/misc';
import { StateSettings, StateProps } from '../types';
import { useHover } from './hover';
import { useActive } from './active';

export function useState(props: StateProps): StateSettings {
  const hover = useHover(props);
  const active = useActive(props);

  const className = clsx(hover.className, active.className);
  const handlers = Misc.mergeCalls(hover.handlers, active.handlers);

  return {
    className,
    handlers,
  };
}
